import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { FcEngineering } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import CustomInput from "../../../CustomComponent/custom_input";
import { Formik, Form, Field } from "formik";
import { ExpenseFormInitialValues } from "../../../SchemaInfo/info";
import { ExpenseFormValidationSchema } from "../../../Schemas/Financial/addFinance_schema";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import LoadingPage from "../../../Components/layouts/loading";
import { useNavigate } from "react-router-dom";
import StepRoutes from "../../../Routes/steps_routes";

const AddFinancialExpense = () => {
  const [loading, setLoading] = useState(false);
  const [expenditureType, setExpenditureType] = useState();
  const [showDates, setShowDates] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    setLoading(true);
    performRequest("POST", `/financial/create-financials/`, values)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          navigate("/financial-dashboard");
          // window.location.reload();
          Toast("success", "Expense Added Successfully!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" /> Add Company Expense
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 d-md-flex">
                  <div className="col-md-3 col-sm-12 py-2 me-3">
                    <div className="card p-2 mb-3">
                      <h3 className="m-0 p-0">Notes:</h3>
                      <hr className="my-1" />
                      <ul className="mb-3">
                        <li>
                          Include all fixed and recurring company expenses.
                        </li>

                        <li>
                          Ensure the <strong>marketing budget</strong> includes
                          both <strong>offline</strong> and{" "}
                          <strong>online</strong> spending.
                        </li>
                        <li>
                          <strong>Manually calculate</strong> and add the{" "}
                          <strong>percentage share</strong> of each category in
                          the total monthly expenditure.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-9 col-sm-12 py-2">
                    <div className="card">
                      <Formik
                        initialValues={ExpenseFormInitialValues}
                        validationSchema={ExpenseFormValidationSchema}
                        onSubmit={handleSubmit}
                      >
                        {(props) => (
                          <Form>
                            <div className="card-body">
                              {/* Expenditure Type */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Expenditure Type
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    name="expenditureType"
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "expenditureType",
                                        e.target.value
                                      );
                                      setShowDates(true);
                                      if (e.target.value === "adHoc") {
                                        setShowDates(false);
                                        props.setFieldValue(
                                          "frequency",
                                          "oneTime"
                                        );
                                      }

                                      setExpenditureType(e.target.value);
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="recurring">Recurring</option>
                                    <option value="fixed">Fixed</option>
                                    {/* <option value="variable">Variable</option> */}
                                    <option value="marketing">Marketing</option>
                                    {/* <option value="adHoc">Adhoc</option> */}
                                  </CustomSelect>
                                  {props.touched.expenditureType &&
                                    props.errors.expenditureType && (
                                      <p className="text-danger">
                                        {props.errors.expenditureType}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Category
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="expenditureCategory" />
                                  {props.touched.expenditureCategory &&
                                    props.errors.expenditureCategory && (
                                      <p className="text-danger">
                                        {props.errors.expenditureCategory}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Frequency
                                </label>
                                <div className="w-100 col">
                                  {expenditureType === "adHoc" ? (
                                    <CustomSelect name="frequency" disabled>
                                      <option value="oneTime">One Time</option>
                                    </CustomSelect>
                                  ) : (
                                    <CustomSelect
                                      name="frequency"
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "frequency",
                                          e.target.value
                                        );
                                        setShowDates(true);
                                        if (e.target.value === "oneTime") {
                                          setShowDates(false);
                                        }
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="oneTime">One Time</option>
                                      <option value="monthly">Monthly</option>
                                      <option value="yearly">Yearly</option>
                                    </CustomSelect>
                                  )}

                                  {props.touched.frequency &&
                                    props.errors.frequency && (
                                      <p className="text-danger">
                                        {props.errors.frequency}
                                      </p>
                                    )}
                                </div>
                              </div>
                              {showDates && (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    StartDate
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput name="startDate" type="date" />
                                    {props.touched.startDate &&
                                      props.errors.startDate && (
                                        <p className="text-danger">
                                          {props.errors.startDate}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}

                              {showDates && (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    EndDate
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput name="endDate" type="date" />
                                    {props.touched.endDate &&
                                      props.errors.endDate && (
                                        <p className="text-danger">
                                          {props.errors.endDate}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                              {/* Description */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Description
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="description" type="text" />
                                  {props.touched.description &&
                                    props.errors.description && (
                                      <p className="text-danger">
                                        {props.errors.description}
                                      </p>
                                    )}
                                </div>
                              </div>
                              {/* Amount */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Total Amount
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="amount" type="text" />
                                  {props.touched.amount &&
                                    props.errors.amount && (
                                      <p className="text-danger">
                                        {props.errors.amount}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            {/* Submit Buttons */}
                            <div className="card-footer">
                              <div className="btn-list justify-content-end">
                                <FormSubmitButton buttonText="Submit Expense" />
                                <SimpleButton
                                  buttonText="Cancel"
                                  type="secondary"
                                />
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddFinancialExpense;
